import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../constants/constants';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit {

  @Input() showContent: string;
  @Input() theme: string;
  @Input() applicationName: string;

  public readonly Constants = Constants;

  public showText: string;
  constructor(
    private modal:  NgbActiveModal,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {

    switch (this.showContent) {
      case Constants.API_DELETE_FAILURE :
          this.translate.get(
            'HOME.DISCOVER_API.API_LIST.DELETE_FAILURE'
          ).subscribe((text) => {
            this.showText = text;
          });
          break;

    }
  }

  public cancel() {
    this.modal.dismiss(false);
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/alert/alert.component.ts